import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createMenu, fetchDropdownMenus, updateMenu } from "../../../Redux/slice/features/menuSlice";
import { fetchPermissions } from "../../../Redux/slice/features/permissionSlice";

const MenuModal = ({ editData, onClose }) => {
    const dispatch = useDispatch();
    const { dropdownMenus } = useSelector((state) => state.menu);
    const permissions = useSelector(
        (state) => state.permission?.permissions || []
    );

    const [form, setForm] = useState({
        vchMenuName: "",
        intParentId: null,
        vchPath: "",
        vchPermissionCode: "",
        intSortOrder: 1,
        bitStatus: 1,
        vchIconSvg: "",
    });

    useEffect(() => {
        if (editData) setForm(editData);
    }, [editData]);

    useEffect(() => {
        dispatch(fetchPermissions());
        dispatch(fetchDropdownMenus());
    }, [dispatch]);

    const groupedPermissions = permissions.reduce((acc, perm) => {
        if (!acc[perm.vchModule]) acc[perm.vchModule] = [];
        acc[perm.vchModule].push(perm);
        return acc;
    }, {});

    const handleSubmit = async () => {
        try {
            if (!form.vchMenuName) {
                alert("Menu name required");
                return;
            }

            if (editData) {
                await dispatch(updateMenu(form)).unwrap();
            } else {
                await dispatch(createMenu(form)).unwrap();
            }

            onClose();
        } catch (err) {
            console.error(err);
            alert("Something went wrong");
        }
    };

    return (
        <div className="modal fade show d-block admin-modal" tabIndex="-1">
            <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">
                            {editData ? "Edit Menu" : "Add Menu"}
                        </h5>
                        <button className="btn-close" onClick={onClose}></button>
                    </div>

                    <div className="modal-body">
                        <div className="mb-3">
                            <label className="form-label fw-semibold">Menu Name</label>
                            <input
                                className="form-control"
                                value={form.vchMenuName}
                                onChange={(e) =>
                                    setForm({ ...form, vchMenuName: e.target.value })
                                }
                            />
                        </div>

                        <div className="mb-3">
                            <label className="form-label fw-semibold">Parent Menu</label>
                            <select
                                className="form-select"
                                value={form.intParentId || ""}
                                onChange={(e) =>
                                    setForm({ ...form, intParentId: e.target.value || null })
                                }
                            >
                                <option value="">No Parent</option>
                                {dropdownMenus.map((m) => (
                                    <option key={m.intMenuId} value={m.intMenuId}>
                                        {m.vchMenuName}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="mb-3">
                            <label className="form-label fw-semibold">Route</label>
                            <input
                                className="form-control"
                                value={form.vchPath}
                                onChange={(e) =>
                                    setForm({ ...form, vchPath: e.target.value })
                                }
                            />
                        </div>

                        <div className="mb-3">
                            <label className="form-label fw-semibold">Permission</label>
                            <select
                                className="form-select"
                                value={form.vchPermissionCode || ""}
                                onChange={(e) =>
                                    setForm({ ...form, vchPermissionCode: e.target.value })
                                }
                            >
                                <option value="">Select Permission</option>
                                {Object.keys(groupedPermissions).map((module) => (
                                    <optgroup key={module} label={module}>
                                        {groupedPermissions[module].map((perm) => (
                                            <option
                                                key={perm.intPermissionId}
                                                value={perm.vchCode}
                                            >
                                                {perm.vchDescription}
                                            </option>
                                        ))}
                                    </optgroup>
                                ))}
                            </select>
                        </div>

                        <div className="row g-3">
                            <div className="col-md-6">
                                <label className="form-label fw-semibold">Order</label>
                                <input
                                    type="number"
                                    className="form-control"
                                    value={form.intSortOrder}
                                    onChange={(e) =>
                                        setForm({ ...form, intSortOrder: e.target.value })
                                    }
                                />
                            </div>

                            <div className="col-md-6">
                                <label className="form-label fw-semibold">Status</label>
                                <select
                                    className="form-select"
                                    value={form.bitStatus}
                                    onChange={(e) =>
                                        setForm({ ...form, bitStatus: Number(e.target.value) })
                                    }
                                >
                                    <option value={1}>Active</option>
                                    <option value={0}>Inactive</option>
                                </select>
                            </div>
                        </div>

                        <div className="mb-3 mt-3">
                            <label className="form-label fw-semibold">Icon (SVG)</label>
                            <textarea
                                rows="3"
                                className="form-control"
                                value={form.vchIconSvg}
                                onChange={(e) =>
                                    setForm({ ...form, vchIconSvg: e.target.value })
                                }
                            />
                        </div>
                    </div>

                    <div className="modal-footer">
                        <button className="btn btn-secondary" onClick={onClose}>
                            Cancel
                        </button>

                        <button className="btn btn-primary" onClick={handleSubmit}>
                            {editData ? "Update" : "Create"}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MenuModal;